$(document).ready(function () {
    if ($('.BabyPelones__carousel8').length) {
        $('.BabyPelones__carousel8').slick({
            rows: 0,
            slidesToShow: 4,
            slidesToScroll: 1,
            speed: 700,
            autoplaySpeed: 7000,
            arrows: false,
            rows: 4,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    rows: 1,
                    arrows: false,
                    vertical: true,
                    verticalSwiping: true
                }
            }]
        });
    }

});